import { RouteProp } from '@react-navigation/native';
import React from 'react';
import useCareTeamMember from '../../../../../hooks/api/useCareTeamMember';
import { getIntl } from '../../../../../utils/intl';
import CareTeamMemberHeader from '../../../../shared/CareTeam/CareTeamMemberHeader';
import CareTeamMemberList from '../../../../shared/CareTeamMemberList';
import { ProfilesTabParamList, useGoBack } from '../../../../../utils/appNavigationNames';
import { ActionButtonLayout } from '../../../../v2BaseComponents/ActionButtonLayout';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';
import HeaderContainer from '../../../../v2BaseComponents/HeaderContainer';
import Text from '../../../../v2BaseComponents/Text';

const intl = getIntl('AddRelatedCareTeamMemberScreen', {
    AddRelatedCareTeamMemberScreen: 'Choose a related care team member',
});

export type AddRelatedCareTeamMemberScreenOwnProps = {};

export type AddRelatedCareTeamMemberScreenProps = AddRelatedCareTeamMemberScreenOwnProps &
    AddRelatedCareTeamMemberScreenNavigatorProps;

export type AddRelatedCareTeamMemberScreenNavigatorProps = {
    route: RouteProp<ProfilesTabParamList, 'add-related-care-team-member'>;
};

const AddRelatedCareTeamMemberScreen: React.FC<AddRelatedCareTeamMemberScreenProps> = ({
    route: {
        params: { careTeamMemberId, profileId },
    },
}) => {
    const goBack = useGoBack();
    const {
        isLoadingCareTeamMember,
        careTeamMember,
        isLoadingRelatedCareTeamMembers,
        relatedCareTeamMembers,
        addRelatedCareTeamMember,
        isAddingRelatedCareTeamMember,
    } = useCareTeamMember({
        careTeamMemberId,
        medicalProfileId: profileId,
        onAddRelatedCareTeamMemberSuccess: () => {
            goBack();
        },
    });

    const omittedCareTeamMemberList = [
        ...(relatedCareTeamMembers?.relatedCareTeamMembers || []).map((_) => _.careTeamMemberId),
        careTeamMemberId,
    ];

    return (
        <AnimateLoadedContent
            isLoading={
                isLoadingCareTeamMember ||
                isLoadingRelatedCareTeamMembers ||
                isAddingRelatedCareTeamMember ||
                !careTeamMember
            }
        >
            {() =>
                careTeamMember ? (
                    <>
                        <HeaderContainer>
                            <CareTeamMemberHeader
                                careTeamMember={careTeamMember}
                                source={{
                                    source: 'profile',
                                    medicalProfileId: profileId,
                                }}
                                careTeamMemberId={careTeamMemberId}
                            />
                        </HeaderContainer>
                        <ActionButtonLayout scrollable>
                            <CareTeamMemberList
                                renderListStart={() => (
                                    <Text variant="body-1" alignText="center">
                                        {intl('AddRelatedCareTeamMemberScreen')}
                                    </Text>
                                )}
                                profileId={profileId}
                                onSelect={(careTeamMemberId: string) => {
                                    addRelatedCareTeamMember(careTeamMemberId);
                                }}
                                omittedCareTeamMemberIds={omittedCareTeamMemberList}
                            />
                        </ActionButtonLayout>
                    </>
                ) : null
            }
        </AnimateLoadedContent>
    );
};

export default React.memo(AddRelatedCareTeamMemberScreen);
